import { forwardRef, useImperativeHandle, useState, useEffect, useMemo } from 'react';
import { Modal, message } from 'antd';
import styles from './index.module.scss';
import API from '@api/api';
import { LeftOutlined } from '@ant-design/icons';

const RecordModal = forwardRef((props, ref) => {
    const [visible, setVisible] = useState(false);
    const [showLadderRecord, setShowLadderRecord] = useState(false);

    useImperativeHandle(ref, () => ({
        open: () => setVisible(true),
        close: () => setVisible(false),
    }));

    const [recordList, setRecordList] = useState([]);

    const hasRecords = useMemo(() => recordList && recordList.length > 0, [recordList]);

    useEffect(() => {
        if (!visible) return
        listNormalInviteRecords()
    }, [visible])

    const listNormalInviteRecords = () => {
        if (!localStorage.getItem('token')) return
        API.listNormalInviteRecords({
        }).then((res) => {
            if (res.code == 0) {
                setRecordList(res.data)
            }
        })
    }

    const getLadderInvitationList = () => {
        if (!localStorage.getItem('token')) return
        setShowLadderRecord(true)
        API.ladderInvitationList({
        }).then((res) => {
            if (res.code == 0) {
                setRecordList(res.data)
            }
        })
    }

    return (
        <Modal
            open={visible}
            onCancel={() => setVisible(false)}
            footer={null}
            width={1000}
            centered={false}
            className={styles.invitationRecordModal}
            style={{ top: 245 }}
            zIndex={1003}
        >
            <div className={styles.modalContent}>
                {
                    showLadderRecord ? (
                        <h2 className={styles.title}><LeftOutlined onClick={() => { listNormalInviteRecords(); setShowLadderRecord(false) }} /> <span>往期天梯赛邀请记录</span><span></span></h2>
                    ) : (
                        <h2 className={styles.title}><span></span>邀请记录<span></span></h2>
                    )
                }
                {hasRecords ? (
                    <>
                        <div className={styles.tableHeader}>
                            <div className={styles.headerItem}>好友账号</div>
                            <div className={styles.headerItem}>{showLadderRecord ? '好友注册时间' : '操作时间'}</div>
                            <div className={styles.headerItem}>记录</div>
                            <div className={styles.headerItem}>{showLadderRecord ? '天梯奖励' : '奖励'}</div>
                        </div>
                        <div className={styles.tableBody}>
                            {recordList.map((record, index) => (
                                <div key={index} className={styles.tableRow}>
                                    <div className={styles.tableCell}>{record.invitee}</div>
                                    <div className={styles.tableCell}>{record.registerTime}</div>
                                    <div className={styles.tableCell}>{record.title}</div>
                                    <div className={styles.tableCell}>{record.bonus}</div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <>
                        <div className={styles.tableHeader}>
                            <div className={styles.headerItem}>好友账号</div>
                            <div className={styles.headerItem}>{showLadderRecord ? '好友注册时间' : '操作时间'}</div>
                            <div className={styles.headerItem}>记录</div>
                            <div className={styles.headerItem}>{showLadderRecord ? '天梯奖励' : '奖励'}</div>
                        </div>
                        <div className={styles.emptyState}>
                            <div className={styles.emptyIcon}></div>
                        </div>
                    </>

                )}
                {
                    !showLadderRecord && <p className={styles.remark}>
                        <span>*该活动数据从2025年12月12日开始统计</span>
                        <span onClick={() => getLadderInvitationList()}>往期天梯赛邀请记录</span>
                    </p>
                }
            </div>

        </Modal>
    );
});

export default RecordModal;
